<!-- @format -->

<script>
    import { storeToRefs } from 'pinia';
    import PaymentPromoOld from '../common/PaymentPromoOld.vue';
    import { useHomeStore } from '../stores/home';


    export default {
        props: {
            userLocation: {
                type: Object,
                default: {},
            },
            enemoUrl: {
                type: String,
                default: ""
            }
        },
        data() {
            return {
                config: window.__pt.settings.site,
                culture: window.__pt.settings.site,
                btnText: this.__('messages.see_more_method_payments'),
            };
        },
        setup() {
            const useHome = useHomeStore();
            const { onSearchPaymentMethod } = useHome;
            const { getTopPaymentBanks } = storeToRefs(useHome);

            return { getTopPaymentBanks, onSearchPaymentMethod };
        },
        mounted() {
            if (!window.__pt.settings.rb) {
                this.onSearchPaymentMethod();
            }
        },
        components: { PaymentPromoOld },
        methods: {},
        computed: {},
    };
</script>

<template>
    <div class="main-layout mb-20">
        <PaymentPromoOld :banks="getTopPaymentBanks"
                         :buttonText="btnText"
                         :userLocation="userLocation"
                         :enemoUrl="enemoUrl"></PaymentPromoOld>
    </div>
</template>
